import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import {
  MatomoProvider,
  createInstance,
} from '@datapunt/matomo-tracker-react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const instance = createInstance({
  urlBase: 'https://matomo.idi.ntnu.no/',
  siteId: Number(process.env.REACT_APP_MATAMO_SITE_ID),
  linkTracking: true,
});

ReactDOM.render(
  <MatomoProvider value={instance}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MatomoProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
